(() => {
  const params = new URLSearchParams(window.location.search);
  const piece = params.get('piece');
  const message = document.querySelector('#ag-body');
  if (piece && message && !document.querySelector('[data-ag-quote-page]') && !message.value) message.value = piece + '\n';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || window.Shopify?.designMode) return;
  const targets = document.querySelectorAll('.ag-section-head, .ag-card, .ag-two > div, .ag-step, .ag-page-heading, .ag-product-gallery');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ag-visible');
        observer.unobserve(entry.target);
      });
    }, {threshold: 0.08});
    targets.forEach((target, i) => {
      target.classList.add('ag-reveal');
      target.style.setProperty('--reveal-delay', `${(i % 4) * 65}ms`);
      observer.observe(target);
    });
  }
  const hero = document.querySelector('.ag-hero-photo');
  if (hero && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    let scheduled = false;
    let x = 0;
    let y = 0;
    hero.addEventListener('pointermove', event => {
      const bounds = hero.getBoundingClientRect();
      x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 12;
      y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 12;
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
  const params = new URLSearchParams(window.location.search);
  const piece = params.get('piece');
  const message = document.querySelector('#ag-body');
  if (piece && message && !document.querySelector('[data-ag-quote-page]') && !message.value) message.value = piece + '\n';
        hero.style.setProperty('--drift-x', `${x}px`);
        hero.style.setProperty('--drift-y', `${y}px`);
        scheduled = false;
      });
    });
    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--drift-x', '0px');
      hero.style.setProperty('--drift-y', '0px');
    });
  }

})();

